import { defineComponent as _defineComponent } from 'vue'
interface Props {
  id?: string;
  autoplay?: boolean;
  muted?: boolean;
  containerSize?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'RichVideo',
  props: {
    id: { default: '' },
    autoplay: { type: Boolean, default: true },
    muted: { type: Boolean, default: true },
    containerSize: { type: Boolean, default: false }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})